import React from "react";
import Button from "../button";
import { ButtonVariant } from "../../shared/utils/enums";
import { X } from "lucide-react";

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ title, onClose }) => (
  <div className="flex items-center justify-between p-4 border-b dark:border-gray-700 shrink-0">
    <h3 className="text-lg font-medium text-gray-900 dark:text-white">
      {title}
    </h3>
    <Button
      onClick={onClose}
      variant={ButtonVariant.CLEAR}
      className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 p-1"
      aria-label="Close modal"
    >
      <X className="h-6 w-6" />
    </Button>
  </div>
);

export default ModalHeader;
